import { getOrCreatePreviewRpc, updatePreviewFeedbackRpc } from '../../__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotPreviewService';
import { rpcClient } from './rpcClient';
export const fetchCopilotPreviewV2 = request => {
  return rpcClient.callWithResultUnion(getOrCreatePreviewRpc, {
    request: Object.assign({}, request)
  });
};
export const updateCopilotPreviewFeedback = request => {
  return rpcClient.callWithResultUnion(updatePreviewFeedbackRpc, {
    request: Object.assign({}, request)
  });
};